/**
 * PDP – FAQ Accordion
 * Vanilla JS — no jQuery required.
 * Clicking a trigger toggles the open/closed state of its FAQ item.
 * Only one item can be open at a time (accordion behaviour).
 */
(function () {
  function initFaqAccordion(section) {
    const items = section.querySelectorAll('.pdp-faq-accordion__item');

    items.forEach(function (item) {
      const trigger = item.querySelector('.pdp-faq-accordion__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.contains('pdp-faq-accordion__item--open');

        // Close all items
        items.forEach(function (el) {
          el.classList.remove('pdp-faq-accordion__item--open');
          const btn = el.querySelector('.pdp-faq-accordion__trigger');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });

        // If the clicked item was closed, open it
        if (!isOpen) {
          item.classList.add('pdp-faq-accordion__item--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // Init on page load
  document.querySelectorAll('.pdp-faq-accordion').forEach(initFaqAccordion);

  // Re-init when Shopify injects a new section (theme editor)
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.pdp-faq-accordion');
    if (section) initFaqAccordion(section);
  });
})();
